import { Modal } from '@/components/Modal'
import { Content } from './Content'
import { modalId } from '../hooks/useController'

interface Props {
  simulations: string[]
}

export function Root(props: Props) {
  return (
    <Modal modalId={modalId}>
      <Content simulations={props.simulations} />
    </Modal>
  )
}
